"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _experimentalSettings = require("./experimentalSettings");

Object.keys(_experimentalSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _experimentalSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _experimentalSettings[key];
    }
  });
});